import { Component } from "react";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { HomeUser } from "./HomeUser";
import { HomeAnonimous } from "./HomeAnonimous";


import './Home.css';

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

const mapDispatchToProps = { exibeMensagemErro, limpaMensagem }

export const Home =

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
		render() {

			return (
				<main id="content" className="page-content p-3" >
					<Message />
					<Loading />
					
					{this.props.user && this.props.user.isAnonimo === false &&
						<HomeUser/>
					}

					{this.props.user && this.props.user.isAnonimo === true &&
						<HomeAnonimous/>
					}
					
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
		}

	}
); // router